import { useSimulation } from "@/contexts/SimulationContext";
import * as Tooltip from "@radix-ui/react-tooltip";

const MODES = [
  { key: "live", label: "Live", color: "#00C853" },
  { key: "hybrid", label: "Hybrid", color: "#007AFF" },
  { key: "simulation", label: "Simulation", color: "#FF6B00" },
];

export function ModeSwitcher() {
  const sim = useSimulation();
  const mode = "simulation";
  return (
    <div
      className="flex items-center gap-1 rounded-full p-1"
      style={{ border: "1px solid var(--oim-border)", backgroundColor: "var(--oim-surface-softer)" }}
      data-testid="mode-switcher"
    >
      <Tooltip.Provider>
        {MODES.map((m) => {
          const disabled = m.key !== "simulation";
          const active = m.key === mode;
          const btn = (
            <button
              key={m.key}
              disabled={disabled}
              data-testid={`mode-${m.key}`}
              className="px-3 py-1.5 rounded-full text-[11px] font-heading uppercase tracking-wide transition-colors duration-200 disabled:opacity-40"
              style={active ? { backgroundColor: m.color, boxShadow: `0 0 14px ${m.color}90`, color: "#000" } : { color: "var(--oim-text-muted)" }}
            >
              {m.label}
            </button>
          );
          if (!disabled) return btn;
          return (
            <Tooltip.Root key={m.key}>
              <Tooltip.Trigger asChild>{btn}</Tooltip.Trigger>
              <Tooltip.Portal>
                <Tooltip.Content className="text-[10px] px-2 py-1 rounded-md bg-[var(--oim-surface)] border border-[var(--oim-border)] text-[var(--oim-text-muted)]" sideOffset={6}>
                  Phase 2
                </Tooltip.Content>
              </Tooltip.Portal>
            </Tooltip.Root>
          );
        })}
      </Tooltip.Provider>
    </div>
  );
}
